import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../../../app-config.service';
import {GeneralService} from '../../service/general-service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  today: Date = new Date();
  loginBackground: any;

  constructor(
    private configService: AppConfigService,
    private generalService: GeneralService,
  ) {
  }

  ngOnInit(): void {
    const loginBackground = this.configService.getConfig().api.loginBackground;
    this.generalService.getSystemConfigByName('BackgroundImageLoginPageUrl').subscribe(
      (res) => {
        if (res) {
          this.loginBackground = encodeURI(this.configService.getConfig().api.baseUrl + '/' + res.valueConfig);
        } else {
          if (loginBackground) {
            this.loginBackground = '/assets/image/' + loginBackground;
          } else {
            this.loginBackground = '/assets/image/anh83.jpg';
          }
        }
      },
      (error) => {
        if (loginBackground) {
          this.loginBackground = loginBackground;
        } else {
          this.loginBackground = 'anh83.jpg';
        }
      }
    );


  }

}
